/**
 * Default values for help menu configuration
 */
export const DEFAULT_HELP_MENU_LABEL = "Get help";
export const DEFAULT_HELP_MENU_HEADING = "TeamForm Help";
export const DEFAULT_HELP_MENU_DESCRIPTION =
  "Search for answers on the TeamForm support page, or submit a support request and the TeamForm support team will be happy to assist you.";
export const DEFAULT_HELP_MENU_SUPPORT_LINK_TEXT = "Support docs";
export const DEFAULT_HELP_MENU_STATUS_LINK_TEXT = "Service status";
export const DEFAULT_SHOW_TEAMFORM_SUPPORT_REQUEST = false;
export const DEFAULT_SHOW_CUSTOM_HELP_CONTENT = false;
export const DEFAULT_SHOW_TEAMFORM_HELP_CONTENT = true;
export const MAX_CUSTOM_HELP_LINKS = 6;

// Default custom help content (shown when custom help is enabled but no custom text is set)
export const DEFAULT_CUSTOM_HELP_TITLE = "Internal Support";
export const DEFAULT_CUSTOM_HELP_DESCRIPTION =
  "Contact your internal support team for assistance with company-specific questions and processes.";
